/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.WvActionMenu";
        class ComponentWvActionMenu extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, callback) {
                super(core, container, parent);
                this._isReady = null;
                this._isWaitingMenu = null;
                this._currentCallback = null;
                this._currentActions = null;
                this._actions = {};
                this._currentObject = null;
                this._currentModalSession = null;
                this._currentRequest = null;
                this._selectedAction = null;
                this._busyModalSession = null;
                this.displayActionMenu = (wvActions, wvObject) => {
                    this._log.info("ComponentWvActionMenu.displayActionMenu()");
                    this._currentActions = wvActions;
                    this._actions = {};
                    wvActions.forEach(action => {
                        this._actions[action.Name] = action;
                    }, this);
                    this._currentObject = wvObject;
                    this._selectedAction = null;
                    this._currentModalSession = null;
                    if (!this._isReady) {
                        this._isWaitingMenu = true;
                        return;
                    }
                    // Load the modal
                    let modalSession = 'wvaction-selection-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentModalSession = modalSession;
                        modal.DIV.innerHTML = ComponentWvActionMenu.Html;
                        // Sort the overall content
                        let componentContainer = modal.DIV.querySelector('#wvamComponentContainer');
                        this._core.Helper.setElementTranslation(modal.DIV.querySelector('#wvaSelectHeading'), 'STR_WPT_WV_ACTION_SELECT');
                        let cancelTranslation = this._core.Locale.getTranslation('STR_WPT_CANCEL');
                        modal.DIV.querySelector('#wvaSelectCloseButtonLabel').innerHTML = cancelTranslation;
                        modal.DIV.querySelector('#closeIcon').setAttribute('title', cancelTranslation);
                        modal.DIV.querySelector('#closeIcon').setAttribute('aria-label', cancelTranslation);
                        // Generate the component
                        let bpConfig = {
                            UsePrimaryColour: false
                        };
                        let bpComponent = new Widgets.ComponentButtonPalette(this._core, componentContainer, null, bpConfig, this._actionSelected);
                        bpComponent.present();
                        this._selectedAction = null;
                        let options = [];
                        wvActions.forEach(action => {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`looking at action '${action.Name}'`);
                            }
                            let label = action.DisplayName ? action.DisplayName : action.Name;
                            let option = { Identifier: action.Name, Label: label, Hidden: false, Group: "WorkView Actions" };
                            option.Icon = this._core.Helper.getButtonIcon({
                                Type: "WvAction",
                                Name: action.Name,
                                Class: action.Class,
                                Application: action.Application
                            });
                            options.push(option);
                        }, this);
                        bpComponent.displayOptions(options, this._actionsDisplayed);
                    }
                    else {
                        console.error("unable to WV action menu modal, modal placeholder is already used");
                    }
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("ComponentWvActionMenu._storeHtml()");
                    ComponentWvActionMenu.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._actionsDisplayed = (count) => {
                    this._log.info("ComponentWvActionMenu._actionsDisplayed()");
                    if (count > 0) {
                        this._core.showModal(this._currentModalSession);
                    }
                    else {
                        let modal = this._core.getModal(this._currentModalSession);
                        if (modal) {
                            modal.DIV.innerHTML = '';
                            this._core.returnModal(this._currentModalSession);
                        }
                        this._currentModalSession = null;
                        this._currentActions = null;
                        this._currentObject = null;
                        this._selectedAction = null;
                    }
                };
                this._actionSelected = (actionName) => {
                    this._log.info("ComponentWvActionMenu._actionSelected()");
                    this._selectedAction = this._actions[actionName];
                    if (this._selectedAction) {
                        // Hide and clear down our modal before execution in case the action needs a modal
                        let modal = this._core.getModal(this._currentModalSession);
                        modal.JQ.one('hidden.bs.modal', this._selectDialogClosed);
                    }
                    this._core.hideModal(this._currentModalSession);
                    this._currentModalSession = null;
                };
                this._selectDialogClosed = () => {
                    this._log.info("ComponentWvActionMenu._selectDialogClosed()");
                    if (this._selectedAction) {
                        let modalSession = 'wv-action-' + performance.now();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("created modal session: " + modalSession);
                        }
                        if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                            this._busyModalSession = modalSession;
                        }
                        this._currentRequest = {
                            Application: this._selectedAction.Application,
                            Class: this._selectedAction.Class,
                            Action: this._selectedAction.Name,
                            ObjectId: this._currentObject.Id
                        };
                        this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/ExecuteAction', JSON.stringify(this._currentRequest), this._actionCompleted, {}, this._actionError, this._actionFailure);
                    }
                };
                this._actionCompleted = () => {
                    this._log.info("ComponentWvActionMenu._actionCompleted()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    if (this._currentCallback) {
                        this._currentCallback(this._currentRequest);
                    }
                    this._selectedAction = null;
                    this._currentRequest = null;
                };
                this._actionError = (url, status, message) => {
                    this._log.info("ComponentWvActionMenu._actionError()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    this._selectedAction = null;
                    this._currentRequest = null;
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_WV_ACTION_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + message;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_WV_ACTION", "STR_WPT_ERROR", msgBody);
                };
                this._actionFailure = (json) => {
                    this._log.info("ComponentWvActionMenu._actionFailure()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    this._selectedAction = null;
                    this._currentRequest = null;
                    let response = json;
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_WV_ACTION_ERROR_MSG');
                    let msgBody = msgPrefix;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        msgBody += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningServiceModal("STR_WPT_WV_ACTION", "STR_WPT_ERROR", msgBody);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentWvActionMenu::constructor");
                this._isReady = false;
                this._isWaitingMenu = false;
                this._currentCallback = callback;
                if (!ComponentWvActionMenu.Html) {
                    core.Loader.getVersionedHTML('widgets/components/wvActionMenu.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("ComponentWvActionMenu._present()");
                this._isReady = true;
                if (this._log.isTraceEnabled()) {
                    this._log.trace("WV action menu ready, checking actions waiting...");
                }
                if (this._isWaitingMenu) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("displaying menu...");
                    }
                    this._isWaitingMenu = false;
                    this.displayActionMenu(this._currentActions, this._currentObject);
                }
            }
        }
        ComponentWvActionMenu.Html = null;
        Widgets.ComponentWvActionMenu = ComponentWvActionMenu;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
